import React, { useState, useEffect } from "react";
import OfferTypeListForm from "./OfferTypeListForm";
import { getOfferTypes, updateOfferType } from "../../api/OfferType";
import { appTitle } from "../common/GeneralConfigurations";

const ManageOfferTypeListPage = () => {
    const [offertypes, setOfferTypes] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        document.title = `${appTitle} - Offer Types`;

        loadOfferTypes();
        setLoading(false)
    }, []);

    const loadOfferTypes = async () => {
        await getOfferTypes().then((res) => {
            if (res.data !== null) {
                setOfferTypes(res.data);
            } else {
                setOfferTypes([]);
            }
        });
    };

    const handleStatusChange = async (id) => {
        await updateOfferType(id).then(async (res) => {
            if (res.status === 200) {
                await loadOfferTypes();
            }
        })
    };

    return (
        <OfferTypeListForm
            offertypes={offertypes}
            handleStatusChange={handleStatusChange}
            loading={loading}
        />
    );
};

export default ManageOfferTypeListPage;
